const arrayFrases = [
  {frase: 'No hay que ir para atrás ni para darse impulso.', 
  autor: 'Lao Tsé'},
  {frase: 'No hay caminos para la paz; la paz es el camino.', 
  autor: 'Mahatma Gandhi'},
  {frase: 'Haz el amor y no la guerra.', 
  autor: 'John Lennon'},
  {frase: 'La mayor declaración de amor es la que no se hace; el hombre que siente mucho, habla poco.', 
  autor: 'Platón'},
  {frase: 'La más estricta justicia no creo que sea siempre la mejor política.', 
  autor: 'Abraham Lincoln'},
  {frase: 'Estar preparado es importante, saber esperarlo es aún más, pero aprovechar el momento adecuado es la clave de la vida.',
  autor: 'Arthur Schnitzler'},
  {frase: 'El sabio no dice nunca todo lo que piensa, pero siempre piensa todo lo que dice.',
  autor: 'Aristóteles'},
  {frase: 'El mundo es bello, pero tiene un defecto llamado hombre.',
  autor: 'Friedrich Nietzsche'},
  {frase: 'Lo que no te mata, te hace más fuerte.',
  autor: 'Friedrich Nietzsche'},
  {frase: 'De humanos es errar y de necios permanecer en el error.',
  autor: 'Marco Tulio Cicerón'},
  {frase: 'La verdadera sabiduría está en reconocer la propia ignorancia.',
  autor: 'Sócrates'},
  {frase: 'Ninguna persona merece tus lágrimas, y quien se las merezca no te hará llorar.',
  autor: 'Gabriel García Márquez'},
  {frase: 'Nunca rompas el silencio si no es para mejorarlo.',
  autor: 'Beethoven'},
  {frase: 'Es tan corto el amor y tan largo el olvido.',
  autor: 'Pablo Neruda'},
  {frase: 'Sé el cambio que quieres ver en el mundo',
  autor: 'Mahatma Gandhi'},
  {frase: 'Vence la ira con serenidad. Vence la maldad con bondad. Vence el egoísmo con generosidad. Vence la deshonestidad con verdad.',
  autor: 'Buda'},
];

export default arrayFrases;